module.exports = __webpack_public_path__ + "static/media/229BL.abc92a24.jpg";